import { render, staticRenderFns } from "./AllCities.vue?vue&type=template&id=01505fb6&"
import script from "./AllCities.vue?vue&type=script&lang=js&"
export * from "./AllCities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports